module.exports = __webpack_public_path__ + "img/messages.ed7df9ee.png";